import React, { PureComponent } from 'react';
import classNames from 'classnames';
import logger from '../../utils/logger-rum';

interface DialogState {
	open: boolean;
	activeClass: string;
	text: string;
	confirmText: string;
	denyText: string;
	subtext: string;
}

interface DialogProps {
	right?: boolean;
	rightXPixel?: number;
	xPixel?: number;
	yPixel?: number;
	width?: number;
	outsideClicked?(): void;
}

export default class Dialog extends PureComponent<DialogProps> {
	state: DialogState = {
		open: false,
		activeClass: 'closed',
		text: '',
		confirmText: "",
		denyText: "",
		subtext: ""
	};

	callback = (confirmed: boolean, cancelled: boolean): void => {
		logger.warn("callback for dialog not set");
	}

	confirm = (text: string, subtext: string, confirmText: string, denyText: string, callback: (confirmed: boolean, cancelled: boolean) => void) => {
		this.setState({ text: text, subtext: subtext, confirmText: confirmText, denyText: denyText, open: true, activeClass: 'closed' });
		this.callback = callback;
		setTimeout(() => this.setState({ activeClass: 'open' }));
	}

	onConfirm = () => {
		this.callback(true, false);
		this.close();
	}

	onDeny = () => {
		this.callback(false, false);
		this.close();
	}

	onCancel = () => {
		this.callback(false, true);
		this.close();
	}

	close = () => {
		this.setState({ activeClass: 'closed' });
	}

	outsideDialogClicked = () => {
		this.setState({ activeClass: 'closed' });
		if (this.props.outsideClicked) {
			this.props.outsideClicked();
		}
	}

	transitionEnd = (e: any) => {
		if (this.state.activeClass === "closed") this.setState({ open: false });
	}

	render() {
		return this.state.open && (
			<div className={classNames("dialog-wrapper", this.state.activeClass)} onTransitionEnd={this.transitionEnd}>
				<div className="dialog-background" onClick={this.outsideDialogClicked} />

				<div className={classNames("dialog-container", { right: this.props.right })} style={{ left: this.props.xPixel, top: this.props.yPixel, right: this.props.rightXPixel, width: this.props.width }}>
					<div className="dialog-content" onClick={e => e.stopPropagation()}>
						<label>{this.state.text}</label>
						<p>{this.state.subtext}</p>
						<div className="button-row">
							<button className="confirm" onClick={this.onDeny}>{this.state.denyText}</button>
							<button className="dark" onClick={this.onConfirm}>{this.state.confirmText}</button>
						</div>
					</div>
				</div>
			</div>
		)
	}
}